import { render } from "./UserManagement.html?vue&type=template&id=97edc984&scoped=true"
import script from "./UserManagement.js?vue&type=script&lang=js"
export * from "./UserManagement.js?vue&type=script&lang=js"

import "./UserManagement.css?vue&type=style&index=0&id=97edc984&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97edc984"]])

export default __exports__